import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  COURSE_DETAILS_GET,
  COURSE_SET_COMMENT,
  COURSE_DETAILS_RESET,
  COURSE_GET_COMMENTS,
  QUIZ_SEND_ANSWERS,
  QUIZ_RESET,
  COMMENT_VISIBILITY_SET,
  SURVEY_RESET,
  SURVEY_QUESTIONS_GET,
  COURSE_RECOMMEND,
  SURVEY_SEND_ANSWERS,
  EVENT_QUIZ_SEND_ANSWERS,
} from '../actions/coursedetails';

const initialState = {
  sections: [],
  bookmarked: false,
  categories: [],
  comments: {
    allow_reply: false,
    items: [],
  },
  completion: {},
  completion_certificate: false,
  course_status: '',
  cover: '',
  duration: 0,
  expiration_date: null,
  id: null,
  notifications: true,
  quiz: {},
  sequential: null,
  title: '',
  total_activities: null,
  contentNotAvailable: false,
  satisfaction_survey: {},
  description: '',
  recommended_info: {},
};

const courseDetailsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case COURSE_DETAILS_GET._SUCCESS: {
        const { data } = action;
        draft = { ...state, ...data };

        draft.contentNotAvailable = false;
        break;
      }

      case COURSE_DETAILS_GET._REQUEST: {
        draft.contentNotAvailable = false;
        break;
      }

      case COURSE_DETAILS_GET._ERROR: {
        draft.contentNotAvailable = true;
        break;
      }

      case COURSE_DETAILS_RESET: {
        draft = initialState;
        break;
      }

      case COURSE_SET_COMMENT._SUCCESS: {
        break;
      }
      case COURSE_GET_COMMENTS._SUCCESS: {
        const { allow_reply = false, items = [] } = action?.data || {};
        draft.comments.allow_reply = allow_reply || false;
        draft.comments.items = [...(items || [])].reverse();
        break;
      }
      case COMMENT_VISIBILITY_SET._SUCCESS: {
        const {
          data: { id, published },
        } = action;
        draft.comments.items.forEach((c) => {
          if (c.id === id) c.published = published;
        });
        break;
      }
      case EVENT_QUIZ_SEND_ANSWERS._SUCCESS:
      case QUIZ_SEND_ANSWERS._SUCCESS: {
        const { data } = action;
        draft.quiz = { ...data };
        const correct_answers = {};
        const my_answers = {};
        (data.quiz_result || []).forEach((r) => {
          correct_answers[r?.question_id] = r?.correct_answers_ids;
          my_answers[r?.question_id] = r?.given_answers_ids;
        });
        draft.quiz.correct_answers = { ...correct_answers };
        draft.quiz.my_answers = { ...my_answers };
        break;
      }

      case SURVEY_QUESTIONS_GET._SUCCESS: {
        draft.satisfaction_survey = action.response;
        break;
      }

      case QUIZ_RESET: {
        draft.quiz = initialState.quiz;
        break;
      }
      case SURVEY_RESET: {
        const newSurvey = {
          ...initialState.satisfaction_survey,
          completion_status: state.satisfaction_survey?.completion_status,
        };
        draft.satisfaction_survey = newSurvey;
        break;
      }

      case SURVEY_SEND_ANSWERS._SUCCESS: {
        draft.satisfaction_survey.completion_status = 'completed';
        break;
      }

      case COURSE_RECOMMEND._SUCCESS: {
        const { recommended } = action?.data || {};
        draft.recommended_info.recommended = recommended;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default courseDetailsReducer;
